module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', [_c('MarketIconWithBackground', {
    attrs: {
      "text": ((_vm.forecastWindows && _vm.forecastWindows.length > 0
                            ? _vm.forecastWindows.filter(function (fw) { return fw.status === _vm.FORECAST_WINDOW_STATUS.SUBMITTED; }).length
                            : 0) + "/" + (_vm.forecastWindows.length))
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_c('div', [_c('ListIconWithBackground', {
    attrs: {
      "text": ("" + (_vm.forecast.numberOfItems))
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-393b0828","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/general/ForecastInfos.vue
// module id = 3127
// module chunks = 0